/** The shape @normy hands to `getNormalizationObjectKey`. */
type NormalizedObject = { [key: string]: unknown };

/**
 * How @normy decides which objects share a cache entry. Everything carrying a
 * string `id` is normalized under it, so two queries selecting the same object
 * must select the same fields — see `LayoutDefinitionFragment` for what a
 * trimmed selection set does to the ones that don't.
 *
 * Exported rather than written inline in `App.tsx` so tests can exercise the
 * cache with the same rules production runs on.
 */
export const normalizerConfig = {
  devLogging: false,
  getNormalizationObjectKey: (obj: NormalizedObject): string | undefined => {
    if ('contextId' in obj && typeof obj.contextId === 'string') {
      return obj.contextId;
    }
    return typeof obj.id === 'string' ? obj.id : undefined;
  },
};
